/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import styled from "styled-components";

import { StandardInput } from "src/components/UI/Form";

export const ShareInput = styled(StandardInput)`
  display: flex;
  flex: 1;
  background: ${({ theme }) => theme.subtleContrast};
  padding: 8px;
  font-family: "IBM Plex Mono", monospace;
  font-size: 13px;
  height: 30px;
  text-overflow: ellipsis;
`;
